var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { useIntl } from "react-intl";
import { TextField } from "@bolteu/kalep-react";
var durationMultipliers = {
  seconds: 1,
  minutes: 60,
  hours: 3600,
  days: 86400,
  weeks: 7 * 86400,
  months: 30 * 86400,
  years: 365 * 86400
};
function convertDuration(value, from, to) {
  return value * durationMultipliers[from] / durationMultipliers[to];
}
export var TimeIntervalField = function TimeIntervalFieldComponent(_a) {
  var _b;
  var onChange = _a.onChange,
    value = _a.value,
    displayUnit = _a.displayUnit,
    validatorResults = _a.validatorResults,
    _a$sourceUnit = _a.sourceUnit,
    sourceUnit = _a$sourceUnit === void 0 ? "seconds" : _a$sourceUnit,
    label = _a.label,
    name = _a.name,
    isCompact = _a.compact,
    rest = __rest(_a, ["onChange", "value", "displayUnit", "validatorResults", "sourceUnit", "label", "name", "compact"]);
  var validationError = validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0];
  var intl = useIntl();
  var onChangeHandler = React.useCallback(function (change) {
    var parsedValue = change.target.value.trim().length === 0 ? NaN : Number(change.target.value);
    var newValue = Number.isNaN(parsedValue) ? undefined : convertDuration(parsedValue, displayUnit, sourceUnit);
    onChange({
      value: newValue
    });
  }, [displayUnit, onChange, sourceUnit]);
  var displayValue = React.useMemo(function () {
    return value && convertDuration(Number(value), sourceUnit, displayUnit);
  }, [value, sourceUnit, displayUnit]);
  return /*#__PURE__*/React.createElement(TextField, Object.assign({
    error: !!validationError,
    helperText: validationError ? validationError.error : undefined,
    fullWidth: true,
    label: label !== null && label !== void 0 ? label : name,
    value: (_b = String(displayValue)) !== null && _b !== void 0 ? _b : "",
    onChange: onChangeHandler,
    type: "number",
    autoCapitalize: "off",
    autoComplete: "off",
    min: 0,
    step: 1,
    suffix: intl.formatMessage({
      id: "common.duration.".concat(displayUnit)
    }, {
      value: displayValue
    }),
    size: isCompact ? "sm" : undefined
  }, rest));
};